import generatePairs from '@/utils/generate-pairs';

const matchedCard = card => ({
  ...card,
  flipped: false,
  matched: true
});

const unflippedCard = card => ({
  ...card,
  flipped: false
});

export const generateCards = state => {
  const level = state.game.levels[state.level];
  state.cards = generatePairs(level);
  state.options = state.game.levels[state.level].options;
};

export const setCardFlipped = (state, item) => {
  const cardToUpdate = state.cards.find(card => card.id === item.id);
  cardToUpdate.flipped = true;
};

export const setFlippedCardsToMatched = state => {
  state.cards = state.cards.map(card => (card.flipped ? matchedCard(card) : card));
};

export const setAllCardsUnflipped = state => {
  state.cards = state.cards.map(unflippedCard);
};
